import { createStore } from "vuex";

import router from "@/router";
import roleIds from "@/config/roles";
let localeUinfo = localStorage.getItem("userInfo") || null;
let localePermission = localStorage.getItem("localePermission") || [];
let userInfo = {};
if (localeUinfo) {
  userInfo = JSON.parse(localeUinfo);
}
if (localePermission && localePermission.length > 0) {
  localePermission = JSON.parse(localePermission);
}

export default createStore({
  state: {
    userInfo: userInfo,
    isLoading: false,
    permissionList: localePermission,
    isBigWin: true,
    currentClient: null,
    currentOrder: null,
    classifier_menus: [
      {
        label: "l_Deferred_payment_conditions",
        router: "PaymentTerms",
      },
      { label: "l_Banks", router: "BankView" },
      { label: "l_Breaking_rule", router: "BreakingRule" },
      { label: "l_Carrier_types", router: "CarrierType" },
      { label: "l_Client_types", router: "ClientType" },
      { label: "l_Countries", router: "CountryView" },
      { label: "l_Cities", router: "CityView" },
      { label: "l_Cargo_statuses", router: "CargoStatus" },
      { label: "l_Transport_types", router: "CustomTransportTypes" },
      { label: "l_VAT_rates", router: "VatRates" },
      {
        label: "l_Position_of_contact_persons",
        router: "PositionOfContactPersons",
      },
      { label: "l_Product", router: "ProductTypes" },
      { label: "l_Workers_post", router: "WorkersPost" },
      // { label: "l_Document_statuses" },
      { label: "l_Trip_statuses", router: "TripStatus" },
      { label: "l_Request_statuses", router: "RequestStatuses" },
      { label: "l_Packagings", router: "PackagingsView" },
      { label: "l_Order_statuses", router: "OrderStatuses" },
      { label: "l_Request_purposes", router: "ReqPurposes" },
      { label: "l_Rail_stations", router: "RailStations" },
      { label: "l_Request_sources", router: "ReqSources" },
      { label: "l_The_reason_of_refusal", router: "RefusalReason" },
      { label: "l_Auto_pick_up", router: "AutoPickUp" },
    ],
    organization_menu: [
      { label: "l_Companies", router: "OrganizationCompanies" },
      { label: "l_Departments", router: "DepartmentsView" },
      { label: "l_Employees", router: "EmployeesView" },
      { label: "l_Group_of_employees", router: "GroupOfEmployees" },
    ],
    log_menu: [{ label: "l_Session_log", router: "ActionsView" }],
    template_menus: [
      { label: "l_Expense_templates", router: "ExpenseTemplate" },
      // {label: "l_Invoices", router: "InvoicesTemplate"},
    ],
  },
  getters: {
    userInfo(state) {
      return state.userInfo;
    },
    getClassifier(state) {
      return state.classifier_menus;
    },
    getTemplates(state) {
      return state.template_menus;
    },
    getOrganization(state) {
      return state.organization_menu;
    },
    getLogs(state) {
      return state.log_menu;
    },
    hasLogin(state) {
      return Boolean(Object.keys(state.userInfo).length);
    },
    userId(state) {
      if (Object.keys(state.userInfo).length) {
        if (state.userInfo.adminType) {
          return state.userInfo.adminType.guid;
        } else if (state.userInfo.info) {
          return state.userInfo.info.guid;
        }
        return 0;
      } else {
        return 0;
      }
    },
    isAdmin(store) {
      const roleId = store.userInfo?.userInfo?.roles?.[0]?.id;
      if (roleId) {
        return roleIds.admin.includes(roleId);
      }
      return false;
    },
    isSuperAdmin(store) {
      if (Object.keys(store.userInfo).length > 0) {
        if (
          store.userInfo.adminType &&
          store.userInfo.adminType.isSuper === 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    isSalesHead(store) {
      const roleId = store.userInfo?.userInfo?.roles?.[0]?.id;
      if (roleId) {
        return roleIds.salesHead.includes(roleId);
      }
      return false;
    },
    getCurrentClient(state) {
      return state.currentClient;
    },
    getCurrentOrder(state) {
      return state.currentOrder;
    },
  },
  mutations: {
    setUserInfo(state, e) {
      let info = e;
      // console.log(info)
      if (e !== "object") {
        state.userInfo = info;
        localStorage.setItem("userInfo", JSON.stringify(info));
      }
      return null;
    },
    updateUserInfo(state, e) {
      let info = e;
      if (e !== "object") {
        let userInfo = JSON.parse(JSON.stringify(state.userInfo));
        userInfo["info"] = {
          ...userInfo.info,
          ...info,
        };
        state.userInfo = userInfo;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      return null;
    },
    setLoading(state, e) {
      state.isLoading = Boolean(e);
    },
    signOut(state) {
      state.userInfo = {};
      localStorage.setItem("userInfo", JSON.stringify({}));
      router.push({ name: "LoginView" });
    },
    setPermissionList(state, info) {
      if (typeof info != "object") {
        console.log("wrong permission format" + info);
        return;
      }
      state.permissionList = JSON.parse(JSON.stringify(info));
      localStorage.setItem("localePermission", JSON.stringify(info));
    },
    setBigWinType(state, info) {
      state.isBigWin = info;
    },
    setCurrentClient(state, clientData) {
      state.currentClient = clientData;
    },
    setCurrentOrder(state, orderData) {
      state.currentOrder = orderData;
    },
  },
  actions: {},
  modules: {},
});
